import Box from "@mui/material/Box";
import {Typography} from "@mui/material";

export const Home = () => {
    return (<Box>
        <Typography variant="h3" align={'center'} mb={'1em'} mt={'1em'}>
            Gaia-X Academy Temporary Tokens management
        </Typography>
        <Typography>
            This tool allows you to invite for a limited amount of time a non-member of the Association,
            <Typography component={'span'} fontWeight={'bold'}> Login is required.</Typography>
        </Typography>
        <Typography>
            You can also revoke a guest access by using the <Typography variant="body2" component="span">revoke
            access</Typography> link.
        </Typography>
    </Box>)
}